import { render } from "./booking-app.vue?vue&type=template&id=0ade7e92"
import script from "./booking-app.vue?vue&type=script&lang=js"
export * from "./booking-app.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__